'use strict';
import angular from 'angular';
import SiteAlertMessagingController from './site-alert-messaging.controller';
export default angular.module('directives.siteAlertMessaging', [])
    .controller('SiteAlertMessagingController', SiteAlertMessagingController)
    .component('siteAlertMessaging', {
    template: require('./site-alert-messaging.html'),
    controller: SiteAlertMessagingController,
    bindings: {
        message: '<',
        messageType: '<'
    }
})
    .name;
//# sourceMappingURL=index.js.map